import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Product} from '../../models/product';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends AbstractModelService<Product> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/product', Product);
  }
}
